/* eslint-disable max-lines-per-function */
import { useCallback } from 'react';

import { Modal, ModalWidth } from '@dreryk/react-components';

import { statisticsTranslationKeys } from '../../translations';
import { GenerateHealthcareProviderPatientsWithDiagnosisForm } from '../forms/GenerateHealthcareProviderPatientsWithDiagnosisForm';
import { GenerateHealthcareProviderPatientsWithDiagnosisStatisticsButton } from '../forms/buttons/GenerateHealthcareProviderPatientsWithDiagnosisStatisticsButton';

import { GenerateStatisticsModalButtons } from './GenerateStatisticsModalButtons';
import { handleStatisticsRefetch } from './GenerateStatisticsModal.utils';

type GenerateHealthcareProviderPatientsWithDiagnosisStatisticsModalProps = {
   readonly closeModal: VoidFunction;
};

export const GenerateHealthcareProviderPatientsWithDiagnosisStatisticsModal = (
   props: GenerateHealthcareProviderPatientsWithDiagnosisStatisticsModalProps
): JSX.Element => {
   const handleOnSuccess = useCallback(() => {
      handleStatisticsRefetch(props.closeModal);
   }, [props.closeModal]);

   return (
      <Modal
         title={statisticsTranslationKeys.modal.title}
         onCloseRequest={props.closeModal}
         animateVisibility
         width={ModalWidth.NORMAL}
         testId={'generateHealthcareProviderPatientsWithDiagnosisStatisticsModal'}
         visible
      >
         <GenerateHealthcareProviderPatientsWithDiagnosisForm>
            {({ handleSubmit, formState }) => (
               <>
                  <GenerateHealthcareProviderPatientsWithDiagnosisStatisticsButton
                     handleSubmit={handleSubmit}
                     onSuccess={handleOnSuccess}
                  />
                  <GenerateStatisticsModalButtons
                     handleClose={props.closeModal}
                     shouldConfirmExit={formState.isDirty}
                  />
               </>
            )}
         </GenerateHealthcareProviderPatientsWithDiagnosisForm>
      </Modal>
   );
};
